import { Menu } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import React, { useState, PropsWithChildren, Attributes } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { MenuProps } from '@material-ui/core/Menu';
import clsx from 'clsx';
import { enhanceChildrenProps } from '../utils/ChildrenPropsEnhancer';

export const ExpandableMenu = (props: PropsWithChildren<ExpandableMenuProps>): JSX.Element => {
    const [anchorElement, setAnchorElement] = useState<HTMLElement | undefined>(undefined);

    const { name, anchorOrigin, transformOrigin, classes } = props;

    const handleClose = (): void => {
        setAnchorElement(undefined);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
        setAnchorElement(event.currentTarget);
    };

    const iconClass = clsx(classes && classes.icon);
    const buttonClass = clsx(classes && classes.button);
    const menuPaperClass = clsx(classes && classes.menuPaper);

    const Icon = props.icon;

    const menuItems = enhanceChildrenProps(props, (originalProps: Partial<any> & Attributes) => ({
        ...originalProps,
        onClick: (...args: any[]) => {
            if (originalProps.onClick) {
                originalProps.onClick(args);
            }
            handleClose();
        }
    }));

    return (
        <React.Fragment>
            <IconButton aria-owns={anchorElement ? name : undefined} aria-haspopup="true" onClick={handleClick} className={buttonClass}>
                <Icon className={iconClass} />
            </IconButton>
            <Menu
                id={name}
                getContentAnchorEl={undefined}
                anchorEl={anchorElement}
                open={Boolean(anchorElement)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                    ...anchorOrigin
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                    ...transformOrigin
                }}
                classes={{ paper: menuPaperClass }}
            >
                {menuItems}
            </Menu>
        </React.Fragment>
    );
};

interface IOwnProps {
    icon: React.ComponentType<SvgIconProps>;
    name: string;
    classes?: Partial<Record<'icon' | 'button' | 'menuPaper', string>>;
}

type ExpandableMenuProps = IOwnProps & Pick<MenuProps, 'transformOrigin' | 'anchorOrigin'>;
